module.exports = __webpack_public_path__ + "static/how_to_security_system-445e292e5361253317da08d8ac457998.png";